import { all, call, put, takeEvery } from 'redux-saga/effects';
import { getRefReqTemplates } from '../../../services/emailTemplateService';
import addRefsSaga from '../containers/AddReferencesStep/sagas';
import step2Saga from '../containers/Step2/sagas';
import step3Saga from '../containers/Step3/sagas';
import step4Saga from '../containers/Step4/sagas';
import step5Saga from '../containers/Step5/sagas';
import { fetchRefReqEmailTemplatesRoutine } from '../routines';

function* fetchRefReqTempate() {
  try {
    const response = yield call(getRefReqTemplates);
    yield put(fetchRefReqEmailTemplatesRoutine.success(response));
  } catch (error) {
    yield put(fetchRefReqEmailTemplatesRoutine.failure(error.message));
  }
}

function* fetchRefReqTempateRequest() {
  yield takeEvery(fetchRefReqEmailTemplatesRoutine.TRIGGER, fetchRefReqTempate);
}

export default function* requestBuilderSaga() {
  yield all([
    fetchRefReqTempateRequest(),
    step2Saga(),
    step3Saga(),
    step4Saga(),
    step5Saga(),
    addRefsSaga()
  ]);
}
